enum OnboardingModes {
  NONE = 'none',
  BROWSER = 'browser',
  USER = 'user'
}

export { OnboardingModes };
